import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'documentFormat',
    pure: true,
    standalone: false
})
export class DocumentFormatPipe implements PipeTransform {
  constructor(private translateService: TranslateService, private sanitizer: DomSanitizer) {}

  transform(row: any, ...args: unknown[]): SafeHtml {
    if (row && row.url) {
      const linkText = this.translateService.instant('modules.mission.mission_anomaly_grid.document');
      const html = `<a href="${row.url}" target="_blank">${linkText}</a>`;
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    return '';
  }
}